"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../constants/index");
exports.passwordValidator = function (control) {
    return control.value.length < index_1.MIN_PASSWORD_LENGTH
        ? { length: { value: control.value.length } }
        : null;
};
//# sourceMappingURL=password.validator.js.map